import { CreateReconContractMappingPayload, ReconContractMapping, ReconPhysicalCode, UpdateReconContractMappingPayload } from "../../../Types/ContractMap.type";
import axiosInstance from "../../../Utils/axiosInstance";


const LIST_URL = "/paper-app/recon-map-contract/";
const DETAIL_URL = "/paper-app/contract-mapping-detail/";    
const BULK_URL   = "/paper-app/contract-mapping-bulk-delete/";
const PHYSICAL_CODE_RECON_URL = "/paper-app/physical-codes-recon/";


export const fetchReconContractMappings = async (): Promise<
  ReconContractMapping[]
> => {
  const response = await axiosInstance.get<ReconContractMapping[]>(LIST_URL);
  return response.data;
};


export const createReconContractMapping = async (
  payload: CreateReconContractMappingPayload
): Promise<ReconContractMapping> => {
  const response = await axiosInstance.post<ReconContractMapping>(LIST_URL, payload);
  return response.data;
};


export const updateReconContractMapping = async (
  payload: UpdateReconContractMappingPayload
): Promise<ReconContractMapping> => {
  const { id, ...body } = payload;
  const response = await axiosInstance.put<ReconContractMapping>(
    `${DETAIL_URL}${id}/`,
    body
  );
  return response.data;
};

export const deleteReconContractMapping = async (
  id: string
): Promise<void> => {
  await axiosInstance.delete(`${DETAIL_URL}${id}/`);
};

export const bulkDeleteReconContractMappings = async (
  ids: string[]
): Promise<void> => {
  await axiosInstance.delete(BULK_URL, { data: { ids } });
};

export const fetchReconPhysicalCodes = async (): Promise<ReconPhysicalCode[]> => {
  const response = await axiosInstance.get<ReconPhysicalCode[]>(PHYSICAL_CODE_RECON_URL);
  return response.data;
};